import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Menu.css";
import { useSelector, useDispatch } from "react-redux";
import { deletePendingTable, getAllPendingTables } from "../Redux/Actions/pendingTableActions";


function Menu() {
  const [menuData, setMenuData] = useState([]);
  const [selectedIngredients, setSelectedIngredients] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [additionItems, setAdditionItems] = useState([]);
  const [tableNumber, setTableNumber] = useState("");
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [discount, setDiscount] = useState(0);
  const [discountCode, setDiscountCode] = useState("");
  const [selectedTable, setSelectedTable] = useState(null);
  const [selectedTables, setSelectedTables] = useState(new Set());

  const dispatch = useDispatch();

  const pendingTables = useSelector((state) => state.pendingTableReducer.pendingTables);

  useEffect(() => {
    localStorage.setItem("pendingTables", JSON.stringify(pendingTables));
  }, [pendingTables]);

  useEffect(() => {
    dispatch(getAllPendingTables());
  }, [dispatch]);

  const handleTableClick = (table) => {
    setSelectedTable(table);
  };

  useEffect(() => {
    const fetchMenuData = async () => {
      try {
        const response = await axios.get("/api/Product/getProduct");
        setMenuData(response.data);
      } catch (error) {
        console.error("Erreur lors du chargement des données du menu:", error);
      }
    };

    fetchMenuData();
  }, []);

  const filteredProducts = selectedCategory
    ? menuData.filter((product) => product.category === selectedCategory)
    : [];

  const toggleSubProducts = (productId) => {
    setSelectedProduct((prev) => (prev === productId ? null : productId));
  };

  const handleSubProductClick = (subProductId, subProductName, price, parentDealId) => {
    if (!tableNumber) {
      alert("Veuillez d'abord choisir une table avant d'ajouter des articles.");
      return;
    }
  
    // Trouver le DEAL parent spécifique
    const parentDeal = menuData.find(product => 
      product._id === parentDealId && product.category === "DEALS"
    );
  
    if (parentDeal) {
      const existingDealIndex = additionItems.findIndex(item => 
        item.isDeal && item.dealId === parentDeal._id
      );
  
      if (existingDealIndex >= 0) {
        setAdditionItems(prev =>
          prev.map((item, index) =>
            index === existingDealIndex
              ? {
                  ...item,
                  subProducts: [
                    ...item.subProducts,
                    { 
                      id: subProductId, 
                      name: subProductName,
                      price,
                      parentDealId: parentDeal._id // Stocker l'ID du parent
                    }
                  ]
                }
              : item
          )
        );
      } else {
        setAdditionItems(prev => [
          ...prev,
          {
            id: parentDeal._id,
            dealId: parentDeal._id,
            name: parentDeal.name,
            price: parentDeal.price,
            quantity: 1,
            isDeal: true,
            subProducts: [{ 
              id: subProductId, 
              name: subProductName,
              price,
              parentDealId: parentDeal._id
            }]
          }
        ]);
      }
 
    } else {
      // Logique pour les produits normaux
      const existingItemIndex = additionItems.findIndex(item => 
        !item.isDeal && item.id === subProductId
      );
  
      if (existingItemIndex >= 0) {
        setAdditionItems(prev =>
          prev.map((item, index) =>
            index === existingItemIndex
              ? { ...item, quantity: item.quantity + 1 }
              : item
          )
        );
      } else {
        setAdditionItems(prev => [
          ...prev,
          { 
            id: subProductId, 
            name: subProductName, 
            price, 
            quantity: 1,
            isDeal: false 
          }
        ]);
      }
    }
  };

  const calculateTotalTTC = () => {
    const total = additionItems?.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const discountedTotal = (total - (total * discount) / 100);
    return discountedTotal.toFixed(2);
  };
  
  const calculateTotal = () => {
    const total = additionItems?.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const discountedTotal = (total - (total * discount) / 100) / 1.07;
    return discountedTotal.toFixed(2);
  };
  
  const calculateTva = () => {
    const tva = additionItems?.reduce((sum, item) => sum + (item.price * item.quantity) * 0.07, 0);
    return tva.toFixed(2);
  };

  const handleTableNumberInput = (num) => {
    if (num === "DEL") {
      setSelectedTables((prev) => {
        const newSet = new Set(prev);
        newSet.delete(tableNumber);
        return newSet;
      });
      setTableNumber("");
      setAdditionItems([]);
    } else {
      setTableNumber(num);
      setSelectedTables((prev) => new Set(prev).add(num));
      setAdditionItems(pendingTables[num]?.items || []);
    }
  };

  const lockTable = async () => {
  if (!tableNumber || additionItems.length === 0) {
    alert("Veuillez sélectionner une table et ajouter des articles.");
    return;
  }

  try {
    // Préparer les items en conservant la structure des DEALs
    const itemsToLock = [...additionItems];

    await axios.post(`/api/PendingTables/addPendingTable`, {
      tableNumber,
      items: itemsToLock,
      status: "locked",
      createdAt: new Date()
      
    });
    

    dispatch(getAllPendingTables());
    alert(`Table ${tableNumber} verrouillée avec succès !`);
    
    
    setTableNumber("");
    setAdditionItems([]);
    
  } catch (error) {
    console.error("Erreur lors du verrouillage :", error);
    alert("Erreur lors du verrouillage");
  }
};
  

  const printAddition = () => {
    const printableContent = `
      <div style="font-family:monospace; text-align:center">
        <h2>SPINTOSS JM</h2>
        <h3>Reçu de paiement</h3>
        <hr/>
        ${additionItems.map(item => (
          `<div>${item.name} x${item.quantity} : ${(item.price * item.quantity).toFixed(2)} DT</div>`
        )).join('')}
        <hr/>
        <div>TotalHT : ${calculateTotal()} DT</div>
        <div>TVA : ${calculateTva()} DT</div>
        <div>TotalTTC : ${calculateTotalTTC()} DT</div>
        <div>Remise : ${discount}%</div>
        <div>Moyen de paiement : ${paymentMethod}</div>
        <hr/>
        <div>Merci et à bientôt !</div>
      </div>
    `;

    const printWindow = window.open('', '', 'width=600,height=400');
    printWindow.document.write(printableContent);
    printWindow.document.close();
    printWindow.print();
  };

  const confirmAddition = async () => {
    if (!paymentMethod) {
      alert("Veuillez sélectionner un mode de paiement !");
      return;
    }
  
    if (!tableNumber || additionItems.length === 0) {
      alert("Veuillez sélectionner une table et ajouter des articles.");
      return;
    }
  
    setLoading(true);
    let paymentSuccess = false; // Indicateur de succès du paiement
  
    try {
      const response = await axios.post("/api/Bills/createBill", {
        tableNumber,
        items: additionItems,
        paymentMethod,
        discount,
        total: calculateTotal(),
        tva: calculateTva(),
        date: new Date()
      });
  
      if (response && response.status >= 200 && response.status < 300) {
        paymentSuccess = true;
        for (const item of additionItems) {
          if (item.isDeal) {
            for (const subProduct of item.subProducts) {
              await processStockDeduction(subProduct.id, item.quantity);
            }
          } else {
            await processStockDeduction(item.id, item.quantity);
          }
        }
        printAddition();
        setTimeout(resetVars(),1000);
      } else {
        console.error("Erreur inattendue lors de la création de la facture :", response);
        alert("Échec du paiement. Veuillez réessayer.");
      }
  
    } catch (error) {
      console.error("Erreur lors du paiement :", error);
      alert("Échec du paiement. Veuillez réessayer. ");
    } finally {
      setLoading(false);
      if (!paymentSuccess) {
        console.warn("Le paiement a échoué, le stock n'a pas été déduit.");
        // Ici, on s'assure (encore une fois) que la déduction n'a pas eu lieu ou qu'elle est annulée si nécessaire.
        // Selon votre logique, vous pourriez même envisager de 'récupérer' un état de stock précédent si cela est géré.
      }
    }
  };
  
  function resetVars(){
    
      dispatch(deletePendingTable(tableNumber));
      setAdditionItems([]);
      setTableNumber("");
      setPaymentMethod(null);
      alert("Paiement effectué avec succès !");
     
  }
  // Fonction helper pour déduire du stock
  const processStockDeduction = async (productId, quantity) => {
    const technicalSheetResponse = await axios.get(
      `/api/TechnicalSheet/onesheetbyproduct/${productId}`
    );
    const technicalSheet = technicalSheetResponse.data;
    
    for (const row of technicalSheet.rows) {
      const stockResponse = await axios.get(
        `/api/Stock/stockByIngredient/${row.ingredient}`
      );
      const stock = stockResponse.data;
      if (stock) {
        stock.totalQuantity -= row.quantity * quantity;
        await axios.put(`/api/Stock/update`, stock);
      }
    }
  };

  const deleteItem = (id) => {
  setAdditionItems(prev => prev.filter(item => item.id !== id));
};

  const modifyItem = (id, newQuantity) => {
    if (newQuantity < 1) return;
    setAdditionItems((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, quantity: newQuantity } : item
      )
    );
  };

  const handlePaymentMethod = (method) => {
    setPaymentMethod(method);
  };

  const applyDiscount = (percentage) => {
    setDiscount(percentage);
  };

  const validateDiscountCode = () => {
    const isValidCode = (code) => {
      const regex = /^(\d{4})-(2023)$/;
      const match = code.match(regex);
      if (match) {
        const part1 = parseInt(match[1], 10);
        return part1 >= 1 && part1 <= 1000;
      }
      return false;
    };

    if (isValidCode(discountCode)) {
      setDiscount(10);
      alert("Code de réduction appliqué !");
    } else {
      alert("Code invalide.");
    }
  };

  const switchTable = (tableNum) => {
    setTableNumber(tableNum);
    setAdditionItems(pendingTables[tableNum] || []);
  };

  return (
    <div className="menu-container">
      <div className="menu-section">
        <div className="catego-buttons">
          <button
            className={`catego-button ${selectedCategory === "FOOD" ? "active" : ""}`}
            onClick={() => {
              setSelectedCategory("FOOD");
              setSelectedProduct(null);
            }}
          >
            FOOD
          </button>
          <button
            className={`catego-button ${selectedCategory === "BEVERAGES" ? "active" : ""}`}
            onClick={() => {
              setSelectedCategory("BEVERAGES");
              setSelectedProduct(null);
            }}
          >
            BEVERAGES
          </button>
          <button
            className={`catego-button ${selectedCategory === "DEALS" ? "active" : ""}`}
            onClick={() => {
              setSelectedCategory("DEALS");
              setSelectedProduct(null);
            }}
          >
            DEALS
          </button>
        </div>

        {selectedCategory && (
          <div>
            {selectedProduct ? (
              <div className="sub-product-container">
                {(() => {
                  const product = menuData.find(
                    (product) => product._id === selectedProduct
                  );
                  const subProducts = product?.subProducts || [];
                  const rows = [];
                  for (let i = 0; i < subProducts.length; i += 7) {
                    rows.push(subProducts.slice(i, i + 7));
                  }

                  return rows.map((row, rowIndex) => (
                    <div key={rowIndex} className="sub-product-row">
                     {row.map((subProduct) => (
                    <button
                      key={`${product._id}-${subProduct._id}`}
                      className="sub-product-button"
                      onClick={() =>
                        handleSubProductClick(
                          subProduct._id,
                          subProduct.name,
                          subProduct.price,
                          product._id // Bien passer l'ID du DEAL parent
                        )
                      }
                    >
                      {subProduct.name}
                    </button>
                  ))}
                    </div>
                  ));
                })()}
              </div>
            ) : (
              <div>
                {(() => {
                  const filteredProducts = menuData.filter(
                    (product) => product.category === selectedCategory
                  );
                  const productRows = [];
                  for (let i = 0; i < filteredProducts.length; i += 6) {
                    productRows.push(filteredProducts.slice(i, i + 6));
                  }

                  return productRows.map((row, rowIndex) => (
                    <div key={rowIndex} className="product-row">
                      {row.map((product) => (
                        <button
                          key={product._id}
                          className="product-button"
                          onClick={() => toggleSubProducts(product._id)}
                        >
                          {product.name}
                        </button>
                      ))}
                    </div>
                  ));
                })()}
              </div>
            )}
          </div>
        )}
      </div>

      <div className="workflow-container">
        <div className="table-selection">
          <h3>Sélection de table</h3>
          <div className="table-number-input">
            <h4>Table: {tableNumber || "-"}</h4>
            <select
              onChange={(e) => handleTableNumberInput(e.target.value)}
              className="dropdown"
              value={tableNumber}
            >
              <option value="">Sélectionner une table</option>
              {[...Array(50)].map((_, i) => {
                const num = (i + 1).toString();
                return !selectedTables.has(num) ? (
                  <option key={num} value={num}>
                    {num}
                  </option>
                ) : null;
              })}
            </select>
            <button onClick={() => handleTableNumberInput("DEL")}>DEL</button>
          </div>
        </div>
        <div>
          <h2>Tables en Attente</h2>
          <div className="pending-tables-grid">
            {pendingTables && Object.keys(pendingTables).length > 0 ? (
              Object.keys(pendingTables).map((tableKey) => {
                const table = pendingTables[tableKey];
                return (
                  <button
                    key={table.tableNumber}
                    onClick={() => {
                      setTableNumber(table.tableNumber);
                      setAdditionItems(table.items || []);
                      setPaymentMethod(null);
                    }}
                    className={`table-button ${
                      tableNumber === table.tableNumber ? "selected" : ""
                    }`}
                  >
                    Table {table.tableNumber}
                  </button>
                );
              })
            ) : (
              <p>Aucune table en attente</p>
            )}
          </div>
        </div>

        <div className="column addition-column">
          <div className="addition-section">
            <h3>Addition</h3>
            {additionItems.length === 0 ? (
              <p>Aucun article sélectionné.</p>
            ) : (
              <>
            <table className="addition-table">
  <thead>
    <tr>
      <th>Nom</th>
      <th>Prix</th>
      <th>Quantité</th>
      <th>Total</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {additionItems?.map((item) => (
      <tr key={item.id}>
        <td>
          {item.name}
          {item.isDeal && (
            <div style={{ marginLeft: '15px', fontSize: '0.9em', color: '#666' }}>
              {item.subProducts?.map(sp => `• ${sp.name}`).join(', ')}
            </div>
          )}
        </td>
        <td>{item.price.toFixed(2)} DT</td>
        <td>
          <input
            type="number"
            value={item.quantity}
            onChange={(e) => modifyItem(item.id, parseInt(e.target.value))}
            style={{ width: "50px" }}
          />
        </td>
        <td>{(item.price * item.quantity).toFixed(2)} DT</td>
        <td>
          <button onClick={() => deleteItem(item.id)}>X</button>
        </td>
      </tr>
    ))}
  </tbody>


                  <tfoot>
                    <tr>
                      <td colSpan="3">Total HT</td>
                      <td colSpan="2">{calculateTotal()}DT</td>
                    </tr>
                    <tr>
                      <td colSpan="3">TVA</td>
                      <td colSpan="2">{calculateTva()}DT</td>
                    </tr>
                    <tr>
                      <td colSpan="3">Total TTC</td>
                      <td colSpan="2">{calculateTotalTTC()}DT</td>
                    </tr>
                  </tfoot>
                </table>

                <div className="discount-section">
                  <div className="discount-buttons">
                    <button onClick={() => applyDiscount(10)}>Réduction 10%</button>
                    <button onClick={() => applyDiscount(20)}>Réduction 20%</button>
                  </div>
                  {discount === 10 && (
                    <div className="discount-code">
                      <input
                        type="text"
                        placeholder="Entrez le code de réduction"
                        value={discountCode}
                        onChange={(e) => setDiscountCode(e.target.value)}
                      />
                      <button onClick={validateDiscountCode}>Appliquer</button>
                    </div>
                  )}
                </div>

                <div className="confirm-buttons">
                  <button onClick={lockTable}>Verrouiller la table</button>
                  <button
                    onClick={confirmAddition}
                    disabled={!additionItems.length || !tableNumber}
                    className="confirm-addition-button"
                  >
                    💳 Payer
                  </button>
                </div>
                <div className="payment-section">
                  <h5>Paiement</h5>
                  <div className="payment-buttons">
                    {["Espece", "TPE", "T.Resto", "Glovo"].map((method) => (
                      <button
                        key={method}
                        onClick={() => handlePaymentMethod(method)}
                        className={paymentMethod === method ? "selected" : ""}
                        disabled={!additionItems.length}
                      >
                        {method}
                      </button>
                    ))}
                  </div>
                  {!paymentMethod && <p className="error-message">Sélectionnez un mode de paiement</p>}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Menu;